<template>
  <div class="layout-navbar">
    <div class="logo"  style="margin-left: 20px;">
      <el-link>
        <img :src="companyLogo" alt="公司Logo" />
      </el-link>
    </div>
    <div class="right-menu">
      <!-- <el-dropdown class="hover-effect" v-if="userType !== 5>
          <span class="el-dropdown-link">
            租户：{{tenantName ? tenantName: '--'}}<i v-if="isMulti(tenants)" class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-item></el-dropdown-item>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :key="0" v-if="isMulti(tenants)" @click.native="clearTenant">-全部-</el-dropdown-item>
              <el-dropdown-item v-for="item in tenants" :key="item.id" @click.native="changeTenant(item)">{{item.tenantName}}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown> -->
      <el-dropdown class="hover-effect" v-if="userType !== 5">
                <span class="el-dropdown-link">
                  主体：{{ mainBodyName ? mainBodyName : '--' }}<i v-if="isMulti(mainBodyList)"
                                                                class="el-icon-arrow-down el-icon--right"></i>
                </span>
        <el-dropdown-item></el-dropdown-item>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :key="0" v-if="isMulti(mainBodyList) && userType !== 4" @click.native="clearMainBody">-全部-
          </el-dropdown-item>
          <el-dropdown-item v-for="item in mainBodyList" :key="item.id" @click.native="changeMainBody(item)">
            {{ item.mainBodyName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="hover-effect" @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-user-solid el-icon--right"></i>{{ realName }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <!--<el-dropdown-item command="0">个人信息</el-dropdown-item>-->
          <el-dropdown-item command="1">修改密码</el-dropdown-item>
          <el-dropdown-item divided command="2">退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" :visible.sync="navbarPwdFormVisible" width="30%" :close-on-press-escape="false"
               :close-on-click-modal="false" :show-close="false">
      <el-form :model="pwd" :rules="dataRule" ref="pwd" @keyup.enter.native="dataFormSubmit()"
               label-width="80px" class="password-dialog-form">
        <el-form-item label="原密码" prop="password">
          <el-input type="password" v-model="pwd.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="pwd.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="pwd.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="closePwdDialog()">取消</el-button>
            <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  setDefaultMainBody,
  fetchMainBodyForTenant,
  fetchTenantList,
  getTenantById,
  fetchMainBodyByUserId,
  getMainBodyById,
  updateMyPassword,
  quitLog
} from '@/controller/sys'
import {clearLoginInfo} from '@/utils/common'

export default {
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.pwd.newPassword !== value) {
        callback(new Error('确认密码与新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      tenants: [],
      mainBodyList: [],
      tenantId: '',
      tenantName: '',
      mainBodyId: '',
      mainBodyName: '',
      userType: '',
      navbarPwdFormVisible: false,
      pwd: {
        password: '',
        newPassword: '',
        confirmPassword: '',
        ip:''
      },
      dataRule: {
        password: [{
          required: true,
          message: '原密码不能为空',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '新密码不能为空',
          trigger: 'blur'
        }, {
          min: 5,
          max: 25,
          message: '长度在 5 到 25个字符'
        },
          {
            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]+$/,
            message: '密码必须为数字，字母，特殊字符三种的组合'
          }
        ],
        confirmPassword: [{
          required: true,
          message: '确认密码不能为空',
          trigger: 'blur'
        },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ]
      },
      companyMap: {
        'loginBeijing': {
          name: '北京汽车制造厂有限公司',
          logo: '/img/LogoBeijing.png'
        },
        'login212': {
          name: '二一二越野车有限公司',
          logo: '/img/212logo.png'
        },
        'loginHuanghua': {
          name: '魏桥智行（黄骅）专用车有限公司',
          logo: '/img/Logohuanghua.png'
        },
        'loginLeichi': {
          name: '雷驰新能源汽车有限公司',
          logo: '/img/LogoLeichi.png'
        },
        'loginLingtu': {
          name: '领途汽车有限公司',
          logo: '/img/lingtulogo.jpg'
        },
        // 添加更多公司...
        default: {
          name: '北京汽车制造厂有限公司',
          logo: '/img/qiche.png'
        }
      }
    }
  },
  computed: {
    realName: {
      get() {
        return this.$store.state.user.name
      }
    },
    currentRouteName() {
      return this.$route.params["fromLogin"]|| sessionStorage.getItem('lastLoginCompany')  ||'default'
    },
    companyLogo() {
      return this.companyMap[this.currentRouteName]?.logo || this.companyMap.default.logo
    }

  },
  mounted() {
    if (sessionStorage.getItem('sppwd') == 1) {
      this.navbarPwdFormVisible = true
    }
    this.getClientIP();

  },
  methods: {
    closePwdDialog() {
      if (sessionStorage.getItem('sppwd') != 1) {
        this.navbarPwdFormVisible = false
      } else {
        this.$message.info('请修改默认密码再继续操作！')
      }
    },
    dataFormSubmit() {
      this.$refs['pwd'].validate((valid) => {
        if (valid) {
          updateMyPassword(
              {
                'oldPassword': this.pwd.password,
                'newPassword': this.pwd.newPassword
              }
          ).then(data => {
            if (data && data.code === '00') {
              sessionStorage.removeItem('sppwd')
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
            this.navbarPwdFormVisible = false
          })
        }
      })
    },
    init(type) {
      // console.log('props',props)
      this.userType = type
      switch (type) {
          //超级管理员
        case 1:
          this.listTenants()
          // this.listMainBody()
          break;
          //租户管理员
        case 2:
          this.initTenant()
          break;
          //主体管理员
        case 3:
          getTenantById(
              {}, this.$store.state.user.userInfo.tenantId
          ).then(data => {
            if (data && data.code === '00') {
              this.tenantId = data.body.id
              this.tenantName = data.body.tenantName
              sessionStorage.setItem('tenantId', data.body.id)
              sessionStorage.setItem('tenantName', data.body.tenantName)
            }
          })
          this.initMainBody()
          break;
          //普通用户
        case 4:
          getTenantById(
              {}, this.$store.state.user.userInfo.tenantId
          ).then(data => {
            if (data && data.code === '00') {
              sessionStorage.setItem('tenantId', data.body.id)
              sessionStorage.setItem('tenantName', data.body.tenantName)
              this.tenantId = data.body.id
              this.tenantName = data.body.tenantName
              sessionStorage.setItem('mainBodyId', this.$store.state.user.userInfo.defaultMainBodyId)
              fetchMainBodyByUserId({}, this.$store.state.user.userInfo.id).then(data => {
                if (data && data.code === '00') {
                  this.mainBodyList = data.body
                  let defalutMainBody = this.mainBodyList.filter(item => {
                    return parseInt(sessionStorage.getItem('mainBodyId')) === parseInt(item.id)
                  })
                  this.mainBodyId = defalutMainBody[0].id
                  this.mainBodyName = defalutMainBody[0].mainBodyName
                }
              })

            }
          })
          break;
        default:
          break;
      }
    },
    initTenant() {
      getTenantById(
          {}, this.$store.state.user.userInfo.tenantId
      ).then(data => {
        if (data && data.code === '00') {
          this.tenantId = data.body.id
          this.tenantName = data.body.tenantName
          sessionStorage.setItem('tenantId', this.tenantId)
          sessionStorage.setItem('tenantName', this.tenantName)
          this.listMainBody()
        }
      })
    },
    initMainBody() {
      getMainBodyById(
          {}, this.$store.state.user.userInfo.defaultMainBodyId
      ).then(data => {
        if (data && data.code === '00') {
          this.mainBodyId = data.body.id
          this.mainBodyName = data.body.mainBodyName
          sessionStorage.setItem('mainBodyId', this.mainBodyId)
          sessionStorage.setItem('mainBodyName', this.mainBodyName)
        }
      })
    },
    changeTenant(item, notMulti) {
      sessionStorage.setItem('tenantId', item.id)
      sessionStorage.setItem('tenantName', item.tenantName)
      location.reload()
      if (!notMulti) {
        this.clearMainBody()
        this.listMainBody(item.id)
      }
    },
    changeMainBody(item) {
      sessionStorage.setItem('mainBodyId', item.id)
      sessionStorage.setItem('mainBodyName', item.mainBodyName)
      if (this.$store.state.user.userInfo.typeId === 4) {
        setDefaultMainBody(
            {
              'defaultMainBodyId': item.id
            }
        ).then(data => {
          if (data && data.code === '00') {
            location.reload()
          }
        })
      } else {
        location.reload()
      }
    },
    changeMainBodyHandle(item) {
      this.changeMainBody(item)
    },
    clearTenant() {
      sessionStorage.removeItem('tenantId')
      sessionStorage.removeItem('tenantName')
      this.tenantId = 0
      this.tenantName = '--'
    },
    clearMainBody() {
      sessionStorage.removeItem('mainBodyId')
      sessionStorage.removeItem('mainBodyName')
      this.mainBodyId = 0
      this.mainBodyName = '--'
    },
    listMainBody() {
      if (!sessionStorage.getItem('tenantId')) {
        return
      }
      fetchMainBodyForTenant(
          {
            'pageNo': 1,
            'pageSize': 50,
            'tenantId': sessionStorage.getItem('tenantId')
          }
      ).then(data => {
        if (data && data.code === '00') {
          this.mainBodyList = data.body.records
          if (this.mainBodyList.length === 1 && this.userType !== 2) {
            this.mainBodyId = this.mainBodyList[0].id
            this.mainBodyName = this.mainBodyList[0].mainBodyName
            sessionStorage.setItem('mainBodyId', this.mainBodyId)
            sessionStorage.setItem('mainBodyName', this.mainBodyName)
          } else if (sessionStorage.getItem('mainBodyId') !== null) {
            this.mainBodyId = sessionStorage.getItem('mainBodyId')
            this.mainBodyName = sessionStorage.getItem('mainBodyName')
          }
        } else {
          this.mainBodyList = []
        }
      })
    },
    listTenants() {
      fetchTenantList(
          {
            'pageNo': 1,
            'pageSize': 50,
            'tenantCode': '',
            'tenantName': ''
          }
      ).then(data => {
        if (data && data.code === '00') {
          this.tenants = data.body.records
          if (this.tenants.length === 1) {
            this.tenantId = this.tenants[0].id
            this.tenantName = this.tenants[0].tenantName
            sessionStorage.setItem('tenantId', this.tenantId)
            sessionStorage.setItem('tenantName', this.tenantName)
            this.listMainBody()
          } else {
            if (sessionStorage.getItem('tenantId')) {
              this.tenantId = sessionStorage.getItem('tenantId')
              this.tenantName = sessionStorage.getItem('tenantName')
            }

          }
        } else {
          this.tenants = []
        }
      })
    },
    handleCommand(c) {
      switch (c) {
        case '0':
          break
        case '1':
          //修改密码
          this.navbarPwdFormVisible = true
          break
        case '2':
          quitLog({},this.pwd.ip).then(data => {
            if (data && data.code === '00') {
              clearLoginInfo()
              this.$router.push({name: `${this.$route.params["fromLogin"]|| sessionStorage.getItem('lastLoginCompany')  }`})

            }
          })
          break
        case '3':
          break
        default:
          break
      }
    },
    getClientIP() {
      // 调用公共IP查询服务
      fetch('https://api64.ipify.org?format=json')
          .then(response => response.json())
          .then(data => {
            console.log('客户端真实IP:', data.ip);
            this.pwd.ip = data.ip;
          })
          .catch(error => {
            console.error('获取IP失败:', error);
          });
    }
  }
}
</script>

<style lang="scss">
.layout-navbar {
  height: 51px;
  overflow: hidden;
  position: relative;
  background: url("/img/navbar-bg.png") 0 0px no-repeat;
  background-size: cover;

  .logo {
    float: left;
    height: 100%;
    line-height: 50px;

    a {
      display: inline-block;
      height: 100%;

      img {
        height: 65%;
        vertical-align: middle;
        //margin: 0 10px;
      }

      h1 {
        margin: 0;
        line-height: 50px;
        display: inline-block;
        vertical-align: middle;
        color: #fff;
        font-size: 16px;
      }
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    .hover-effect {
      cursor: pointer;
      padding: 0 20px;
      transition: background .5s;

      span {
        outline: none;
        color: #fff;
        font-size: 14px;

        i {
          font-size: 16px;
          margin-right: 10px;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
}
</style>
